import { GameHeaderConst } from "./GameHeaderConst";
import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { useContext } from "react";
import "./GameHeader.scss";
import { GameContext } from "../../GameContext/GameContext";

const GameHeader = () => {
  const { sort, setSort } = useContext(GameContext);
  const { order, orderBy } = sort;

  const handleRequestSort = (property, ignoredValues) => {
    const isAsc = orderBy === property && order === "asc";
    setSort({ order: isAsc ? "desc" : "asc", orderBy: property, ignoredValues });
  };

  return (
    <TableHead className="game-list-headers">
      <TableRow>
        <TableCell className="game-list-header" />
        {GameHeaderConst.headers.map(({ label, property, disableSort, ignoredValues }) => {
          return (
            <TableCell
              className="game-list-header"
              key={property}
              sortDirection={orderBy === property ? order : false}
            >
              {disableSort ? (
                <div>{label}</div>
              ) : (
                <TableSortLabel
                  active={orderBy === property}
                  direction={orderBy === property ? order : "asc"}
                  onClick={() => handleRequestSort(property, ignoredValues)}
                >
                  {label}
                </TableSortLabel>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default GameHeader;
